<template>
  <div class="filter-container">

    <filter-title
      :show="show"
      :title="title"
      @filter-reset="resetFilter"
      @toggle-description="showDescription = !showDescription"
      @toggle-settings="showSettings = !showSettings"
    ></filter-title>

    <div>
      <filter-description
        :title="title"
        :show="showDescription"
        :description="options.description"
      />

      <filter-settings
        :show="showSettings"
        :items="singleSelectOptions.options"
        :value="singleSelectOptions.value"
        @setting-changed="selectModeChanged"
        :filled="true"
      />

      <v-autocomplete
        dense 
        v-model="value"
        :items="items"
        :menu-props="{closeOnContentClick:true}"
        filled
        single-line
        hide-details
        :filter="filterValues"
        chips
        :placeholder="title + ': Velg eller søk..'"
        label="Velg eller søk.."
        :item-text="options.group ? 'name' : 'NAVNVASSOMR'"
        :return-object="!options.group"
        item-value="name"
        multiple
        @input="updateFilter"
      >
        <template v-slot:selection="data">
          <v-chip
            color="primary"
            :close-label="'Fjern' + customLabel(data.item)"
            small
            class="ma-1"
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click="data.select"
            @click:close="removeSelectedValue(data.item)"
          >
            {{ customLabel(data.item) }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-title v-text="options.group ? data.item : customLabel(data.item)"></v-list-item-title>
          </template>
          <template v-else>
            <v-list-item-content>
              <v-list-item-title v-html="customLabel(data.item)"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
import { FilterTitle } from "@/components/index";
import FilterDescription from "./FilterDescription";
import FilterSettings from "./FilterSettings";
import { mapActions } from "vuex";
import { getQueryStringForMultiselect, getQueryStringForMultiselectUsingLikeOperator } from "./utils.js"

export default {
  name: "FilterMultiSelect",
  data () {
    return {
      value: [],
      showDescription: false,
      showSettings: false
    };
  },
  components: { FilterTitle, FilterDescription, FilterSettings },
  watch: {
    options: {
      handler: function () {
        this.value = this.options.currentValue ? this.options.currentValue : [];
        this.updateFilter(this.value);
      }, deep: true
    }
  },
  props: {
    title: String,
    helptext: String,
    checkboxes: Array,
    parameter: String,
    options: Object,
    show: Boolean,
    singleSelectOptions: {
      default: function () {
        return {
          value: {
            id: "equal",
            name: "Er lik",
            operator: ""
          },
          options: [
            {
              id: "equal",
              name: "Er lik",
              operator: ""
            },
            {
              id: "notEqual",
              name: "Er ulik",
              operator: " NOT"
            }
          ]
        }
      }, type: Object
    },
  },
  computed: {
    items: function () {
      let items = [];
      if (this.checkboxes.length > 0 && this.checkboxes[0].group) {
        this.checkboxes.forEach(group => {
          items.push({ header: group.group })
          group.options.forEach(item => {
            items.push(item);
          });
        });
      } else {
        this.checkboxes.forEach(item => {
          items.push(item);
        });
      }
      return items;
    }
  },
  methods: {
    ...mapActions(["setSelectedMaaleParameter", "setFilterValue"]),
    selectModeChanged: function (evt) {
      this.singleSelectOptions.value = evt;
      this.updateFilter(this.value);
    },
    filterValues: function (item, queryText, itemText) {
      if (this.options.customLabel) {
        let customLabel = this.options.customLabel(item);
        return customLabel.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      } else {
        return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      }
    },
    removeSelectedValue: function (item) {
      const index = this.value.indexOf(item)
      if (index >= 0) {
        this.value.splice(index, 1)
        this.updateFilter(this.value);
      }
    },
    resetFilter: function () {
      this.value = [];
      this.updateFilter(this.value);
    },
    updateFilter: function (selectedValues) {
      
      this.options.currentValue = this.value;
      if (this.parameter === "stasjonParameter") {
        this.setSelectedMaaleParameter(JSON.parse(JSON.stringify(this.value)));
      }
      if (selectedValues.length === 0) {
        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: null
        });
        return;
      }
      if (selectedValues.length > 0) {
        let queryString = this.getQueryString(selectedValues);
        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: queryString
        });
      }
    },
    getQueryString: function (selectedValues) {
      let queryString = '';      
      if (this.options.useLikeOperator) {
        queryString = getQueryStringForMultiselectUsingLikeOperator(selectedValues, {
          parameter: this.parameter,
          filterProperty: this.options.filterProperty,
          operator: this.singleSelectOptions.value.operator
        });        
      } else {
        
        queryString = getQueryStringForMultiselect(selectedValues, {
          parameter: this.parameter,
          operator: this.singleSelectOptions.value.operator,
          skipQuotes: this.options.skipQuotes       
        });        
      }     
      return queryString;
    },
    customLabel (element) {
      if (this.options.customLabel) {
        return this.options.customLabel(element);
      }
      return element;
    }
  },
  created: function () {
    this.$eventHub.$on("reset-all-filters", this.resetFilter);
  }
};
</script>

<style>

</style>

